import * as React from "react";
import { Dialog, Spinner } from "@radix-ui/themes";
import { Id } from "@repo/convex/convex/_generated/dataModel";
import { DialogCloseButton } from "../../common/DialogCloseButton.tsx";
import { useGetOrCreateItemChats } from "../itemChats.ts";
import { ChatMessagesList } from "./ChatMessagesList.tsx";
import { ChatMessageEntryBox } from "./ChatMessageEntryBox.tsx";
import { useQuery } from "convex-helpers/react/cache/hooks";
import { api } from "@repo/convex/convex/_generated/api";
import { itemTitle } from "../../common/items/format.ts";
import "./chat.css";

interface Props {
  itemId: Id<"items"> | null;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => unknown;
}

export const ItemChatDialog: React.FC<Props> = ({ itemId, isOpen, setIsOpen }) => {
  const { chat } = useGetOrCreateItemChats(itemId);
  const item = useQuery(api.items.findMine, itemId ? { itemId } : "skip");

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(isOpen) => {
        if (!itemId) return;
        setIsOpen(isOpen);
      }}
    >
      <Dialog.Content align={"start"} maxWidth="640px" style={{ marginTop: "5vh" }}>
        <Dialog.Title mb={"1"}>Chat about it</Dialog.Title>
        <Dialog.Description color={"gray"} size={"2"} mb={"4"}>
          {item ? itemTitle(item) : "\u00a0"}
        </Dialog.Description>

        <DialogCloseButton onClick={() => setIsOpen(false)} />

        <div className="chat-panel">
          {chat ? (
            <>
              <ChatMessagesList chatId={chat._id} />
              <ChatMessageEntryBox chatId={chat._id} />
            </>
          ) : (
            <div className="chat-loading">
              <Spinner size={"3"} />
            </div>
          )}
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};
